<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择功能"
      class="customer-edit"
      width="40%"
      top="5vh">
    <div>
      <div class="custom-tree-container">
        <div>
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
          </template>
        </div>
        <el-input
            v-model="filterText"
            style="width: 500px;"
            placeholder="输入关键字进行过滤"/>
        <div style="margin: 20px 40px 20px 0px;">
          <el-tree
              ref="tree"
              :data="data"
              :props="defaultProps"
              :filter-node-method="filterNode"
              node-key="id"
              :expand-on-click-node="false">
            <span slot-scope="{ node, data }" class="custom-tree-node">
              <span>{{data.label+"("+data.other+")"}}</span>
              <span>
                <el-button
                    type="text"
                    style="margin-left: 10px;"
                    @click="onSelect(data)">选择</el-button>
              </span>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>


  export default {
    name:"SystemFunctionSelect",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        data: [],
        filterText: "",
        defaultProps: {
          children: "children",
          label: "",
          other: "",
        },
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic","functions/tree").then((res) => {
            this.data = res;
          });
      },
      filterNode(value, data, node) {
        if (!value) {
          return true;
        }
        if (node.parent.parent !== null && node.parent.visible) {
          return true;
        }
        return data.label.indexOf(value) !== -1;
      },
      onSelect(data) {
        this.$emit("select", data);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
